import ChangeLangButton from './ChangeLangButton';

export default ChangeLangButton;
